import { Link } from 'react-router-dom';

const InfrastructureSystems = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Infrastructure Systems</h1>
          <p>
            We engineer resilient infrastructure that powers critical operations—from intelligent buildings and
            low-current systems to energy management and industrial automation.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container two-column">
          <div>
            <h2>Integrated Building Technologies</h2>
            <p>
              Nexus IT delivers turnkey infrastructure covering electrical, mechanical, and technological disciplines.
              We design smart facilities that are safe, efficient, and adaptive to evolving operational demands.
            </p>
            <ul className="checklist">
              <li>ELV systems including BMS, fire alarm, access control, CCTV, and public address</li>
              <li>Structured cabling and intelligent wiring solutions for voice, data, and IoT devices</li>
              <li>Power distribution, UPS, and backup systems engineered for mission-critical uptime</li>
              <li>Lighting automation, energy monitoring, and sustainability analytics</li>
            </ul>
          </div>
          <div>
            <div className="service-card">
              <h3>Outcome Focused Delivery</h3>
              <ul>
                <li>Concept-to-commissioning ownership</li>
                <li>Compliance with international safety standards</li>
                <li>Lifecycle maintenance strategies for optimized performance</li>
                <li>Integration with existing facility platforms</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Core Disciplines</span>
            <h2 className="section-title">Infrastructure Expertise</h2>
          </div>
          <div className="service-grid">
            <article className="service-card">
              <h3>Electrical Systems</h3>
              <p>LV/MV power distribution, substations, lighting control, switchgear, and surge protection.</p>
            </article>
            <article className="service-card">
              <h3>Mechanical Systems</h3>
              <p>HVAC integration, chillers, ducting, pumps, firefighting, and smoke management solutions.</p>
            </article>
            <article className="service-card">
              <h3>Security &amp; Life Safety</h3>
              <p>Fire detection/suppression, access management, perimeter protection, and emergency communications.</p>
            </article>
            <article className="service-card">
              <h3>Smart Building Platforms</h3>
              <p>BMS orchestration, occupancy analytics, smart metering, and environmental monitoring.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Transform Your Infrastructure</h2>
              <p>Our specialists design reliable environments tailored to your sector’s compliance and operational demands.</p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Arrange a Consultation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default InfrastructureSystems;
